// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../imgs/blob-blue-duo-2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._z3Ru4idCvmhECEHIa7w {
  background-color: var(--secondary-alt-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: right;
  background-position-y: 30%;
  background-size: auto 90%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - var(--global-nav-height));
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.QsMLQQ701T2Ni2gwU9HQ h2 {
  display: flex;
  justify-content: flex-start;
  font-size: var(--step-3);
  color: var(--white-color);
}

.QsMLQQ701T2Ni2gwU9HQ p {
  color: var(--white-color);
  text-wrap: balance;
  text-align: left;
  padding-top: 1rem;
  padding-bottom: 2rem;
  font-size: var(--step-0);
  line-height: var(--base-line-height);
}

.DQ1j90Mlp5Y_RJmPMR3w {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  gap: var(--space-2xl);
  padding-inline: var(--space-4xs-5xl);
  min-height: calc(90vh - var(--global-nav-height));
}

.QsMLQQ701T2Ni2gwU9HQ {
  margin-left: 5rem;
  flex: 1 1 calc((var(--space-3xl) * 3) + (var(--space-xl) * 2));
}

.gQHynjKF7eAbZzAbCKXt {
  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 1));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.JE9_beBDpqiJVsnPnVwX {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--space-s);
}

.q8uufm_G_b2lKM6gOeor {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  gap: var(--space-s-m);
}

.q8uufm_G_b2lKM6gOeor > * {
  margin: 0;
  white-space: normal;
}

.aEyH8k10xD32C4u5BlrO {
  font-size: var(--step-5);
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);
  text-align: center;
  background: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  transition: var(--global-nav-transition);
  cursor: pointer;
  z-index: 200;
}

.aEyH8k10xD32C4u5BlrO:hover,
.aEyH8k10xD32C4u5BlrO:focus {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);
}

.aEyH8k10xD32C4u5BlrO:active {
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
}

.ViIIkwcfg71MLbvBMFSC {
  display: flex;
  flex-direction: column;
  width: min-content;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/FeaturedTopicsSection.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,yDAAyD;EACzD,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".featuredTopics {\n  background-color: var(--secondary-alt-color);\n  background-image: url(../../../imgs/blob-blue-duo-2x.png);\n  background-position-x: right;\n  background-position-y: 30%;\n  background-size: auto 90%;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: calc(100vh - var(--global-nav-height));\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.colL h2 {\n  display: flex;\n  justify-content: flex-start;\n  font-size: var(--step-3);\n  color: var(--white-color);\n}\n\n.colL p {\n  color: var(--white-color);\n  text-wrap: balance;\n  text-align: left;\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n  font-size: var(--step-0);\n  line-height: var(--base-line-height);\n}\n\n.sectionContent {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-content: center;\n  gap: var(--space-2xl);\n  padding-inline: var(--space-4xs-5xl);\n  min-height: calc(90vh - var(--global-nav-height));\n}\n\n.colL {\n  margin-left: 5rem;\n  flex: 1 1 calc((var(--space-3xl) * 3) + (var(--space-xl) * 2));\n}\n\n.colR {\n  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 1));\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.pillLinkList {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-s);\n}\n\n.btnGroup {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: center;\n  gap: var(--space-s-m);\n}\n\n.btnGroup > * {\n  margin: 0;\n  white-space: normal;\n}\n\n.pageDownBtn {\n  font-size: var(--step-5);\n  color: rgba(255, 255, 255, 0.9);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);\n  text-align: center;\n  background: none;\n  background-color: transparent;\n  border: none;\n  text-decoration: none;\n  transition: var(--global-nav-transition);\n  cursor: pointer;\n  z-index: 200;\n}\n\n.pageDownBtn:hover,\n.pageDownBtn:focus {\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);\n}\n\n.pageDownBtn:active {\n  color: rgba(255, 255, 255, 0.8);\n  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n}\n\n.pageDownBtnWrapper {\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredTopics": `_z3Ru4idCvmhECEHIa7w`,
	"colL": `QsMLQQ701T2Ni2gwU9HQ`,
	"sectionContent": `DQ1j90Mlp5Y_RJmPMR3w`,
	"colR": `gQHynjKF7eAbZzAbCKXt`,
	"pillLinkList": `JE9_beBDpqiJVsnPnVwX`,
	"btnGroup": `q8uufm_G_b2lKM6gOeor`,
	"pageDownBtn": `aEyH8k10xD32C4u5BlrO`,
	"pageDownBtnWrapper": `ViIIkwcfg71MLbvBMFSC`
};
export default ___CSS_LOADER_EXPORT___;
